export class MemberOrganizationInfoModel {
  bpid: string;
  orgId?: string | undefined;
  orgName: string;
  department: string;
  roles: string[];
  job: string;
  status: string;
  id: string;
  name: string;
  lastname: string;
  email: string;
  initials: string;
  member: boolean;
  complete: boolean;
}

export interface MemberOrganizationInfoResponse {
  memberSince: string;
  lastUpdated: string;
  lastUpdatedTimestamp: number;
  orgName: string;
  bpid: string;
  job?: string;
  orgId: string;
  memberSinceTimestamp: number;
  status: string;
  roles?: string[];
  ssoDefinitions?: SsoDefinitions;
  department?: string;
}

export interface SsoDefinitions {
  rolesDefinedByOrigin: boolean;
}
